import { Routes, Route } from 'react-router-dom';
import LibraryPage from '../pages/Library';
import MyBooksPage from '../pages/MyBooks';
import MainLayout from '../../../components/MainLayout';
import BookDetail from '../pages/BookDetail';
import CategoryBooksPage from '../pages/CategoryBooksPage';
import CollectionDetailsPage from '../pages/CollectionDetailsPage';

export const LibraryRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout>
            <LibraryPage />
          </MainLayout>
        }
      />
      <Route
        path="/my-books"
        element={
          <MainLayout>
            <MyBooksPage />
          </MainLayout>
        }
      />
      <Route
        path="/category/:categoryName"
        element={
          <MainLayout>
            <CategoryBooksPage />
          </MainLayout>
        }
      />
      <Route
        path="/collection/:id"
        element={
          <MainLayout>
            <CollectionDetailsPage />
          </MainLayout>
        }
      />
      {/* Support both /library/book and /library/book/:bookId */}
      <Route path="book" element={<BookDetail />} />
      <Route path="book/:bookId" element={<BookDetail />} />
    </Routes>
  );
};
